import { OrderStatusModel } from '@/domain/models/order/order-model'
import { i18nTranslationHelper } from '@/i18n'

export namespace Order {
  export namespace Status {
    const t = i18nTranslationHelper.getTEnums

    export class Enum implements OrderStatusModel {
      static readonly PENDING = new Enum(-1, 'PENDING', t('orderStatus.PENDING.label'))

      static readonly WAITING_ENROLLMENT = new Enum(
        1,
        'WAITING_ENROLLMENT',
        t('orderStatus.WAITING_ENROLLMENT.label')
      )

      static readonly ERROR_ENROLLMENT = new Enum(
        2,
        'ERROR_ENROLLMENT',
        t('orderStatus.ERROR_ENROLLMENT.label')
      )

      static readonly ONGOING = new Enum(3, 'ONGOING', t('orderStatus.ONGOING.label'))

      static readonly ABANDONED = new Enum(4, 'ABANDONED', t('orderStatus.ABANDONED.label'))

      static readonly FINISHED = new Enum(5, 'FINISHED', t('orderStatus.FINISHED.label'))

      static readonly EVALUATED = new Enum(6, 'EVALUATED', t('orderStatus.EVALUATED.label'))

      private constructor(
        public readonly id: number,
        public readonly name: string,
        public readonly title: string
      ) {}
    }

    export const getById = (id: number): Enum => {
      return Object.values(Order.Status.Enum).find(status => status.id === id)
    }

    export const getByName = (name: string): Enum => {
      return Object.values(Order.Status.Enum).find(status => status.name === name)
    }
  }
}
